import React from 'react';

import WatchListBtn from '../../../watchlist-btn/WatchListBtn';

export type RelatedTeaserProps = {
  id: string;
  overline?: string;
  title: string;
  href: string;
  image: {
    src: string;
    srcSet: string;
    alt?: string;
  };
  intro: string;
  tags?: {
    title: string;
  }[];
  cta: string;
  labels: {
    add: string;
    remove: string;
  };
  hideTeaserButton: boolean;
};

const RelatedTeaser = ({
  id,
  overline,
  title,
  href,
  tags,
  intro,
  image,
  cta,
  labels,
  hideTeaserButton
}: RelatedTeaserProps) => (
  <div className="teaser teaser--visible teaser-container__teaser">
    <a
      href={href}
      title={title}
      className="teaser__link has-hoverable-children"
    >
      <div className="teaser__image">
        <div className="teaser__image-inner">
          <img src={image.src} srcSet={image.srcSet} sizes="" alt={image.alt} />
        </div>
      </div>
      <div className="teaser__content">
        {overline && (
          <p className="teaser__overline typo-label font-uppercase">
            {overline}
          </p>
        )}

        <h3 className="teaser__headline typo-headline-4">{title}</h3>
        <p className="teaser__copy typo-copy">{intro}</p>
        {tags && (
          <div className="search-list__teaser-topics">
            {tags.map((item) => (
              <span key={item.title} className="tag">
                {item.title}
              </span>
            ))}
          </div>
        )}
        <div className="button search-list__teaser-cta">
          <span className="button__icon">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M7.49581 3L12.575 8.07914L7.49581 13.1583L6.67086 12.3333L10.3417 8.66247L3 8.66248V7.49581L10.3417 7.49581L6.67086 3.82496L7.49581 3Z" />
            </svg>
          </span>
          <span className="button__label">{cta}</span>
        </div>
      </div>
    </a>
    {!hideTeaserButton && (
      <WatchListBtn id={id} title={title} labels={labels} />
    )}
  </div>
);

export default RelatedTeaser;
